import ReactSlider from "react-slider";
import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import { FONT_SIZE } from "../../../constants/design/fontSize";
import { BORDER_RADIUS, SPACING } from "../../../constants/design/spacing";

export const SliderWrapper = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  height: 36px;
`;

export const SliderPatternWrapper = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SliderPattern = styled.div<{
  activeColor?: string;
  active?: boolean;
}>`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${COLORS.white.three};
  flex-shrink: 0;
`;

export const SliderBackground = styled.div`
  position: absolute;
  left: 7px;
  right: 7px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const Slider = styled(ReactSlider)`
  flex: 1;
  display: flex;
  align-items: center;
  z-index: 1;
  cursor: grab;
  &:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
  }
`;

export const SliderInputWrapper = styled.div<{ showSlider?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${SPACING.two}px;
  overflow: visible;
  background-color: transparent;
  transition: all 0.25s ease-in-out;

  ${Slider} {
    ${({ showSlider }) =>
      !showSlider &&
      css`
        width: 0;
        opacity: 0;
      `}
  }

  ${SliderWrapper} {
    margin: 0;
  }
`;

export const StyledThumb = styled.div<{ $color?: string; $width?: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid ${({ $color }) => $color || COLORS.highlight.one};
  background-color: ${LAYER_COLORS.one};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
  top: 50% !important;
  transform: translateY(-50%);
  flex-shrink: 0;

  &:active {
    cursor: grabbing;
  }

  &:focus-visible {
    outline: none;
  }
`;

export const StyledTrack = styled.div<{ index: number; $color?: string }>`
  height: 2px;
  border-radius: ${BORDER_RADIUS.full}px;
  background: ${({ index, $color }) =>
    index === 0 ? ($color || COLORS.highlight.one) : LAYER_COLORS.three};
  display: flex;
  align-items: center;
`;

export const PercentInputBox = styled.div`
  display: flex;
  align-items: center;
  background-color: transparent;
  border-radius: 8px;
  border: 1px solid ${BORDER_COLORS.three};
  height: 36px;
  padding: 0 ${SPACING.two}px;
  gap: 2px;
  flex-shrink: 0;
  min-width: 60px;
`;

export const PercentNumberInput = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: ${TEXT_COLORS.one};
  font-size: ${FONT_SIZE.two};
  width: 28px;
  text-align: right;
  padding: 0;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PercentSign = styled.span`
  color: ${TEXT_COLORS.three};
  font-size: ${FONT_SIZE.two};
`;
